// constants

const SET_THANK_YOU_DETAILS = "SET_THANK_YOU_DETAILS";
const REMOVE_THANK_YOU_DETAILS = "REMOVE_THANK_YOU_DETAILS";

// reducers

const initialState = {};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_THANK_YOU_DETAILS:
			if (action.payload === {}) return { ...state };
			return { ...action.payload };
		case REMOVE_THANK_YOU_DETAILS:
			return [];
		default:
			return state;
	}
};
export default Reducer;

// actions

export const setThankYouDetail =
	(obj = {}) =>
	async (dispatch) => {
		dispatch({
			type: SET_THANK_YOU_DETAILS,
			payload: obj,
		});
	};

export const emptyThankYouDetail = () => async (dispatch) => {
	dispatch({
		type: REMOVE_THANK_YOU_DETAILS,
	});
};
